import { userRoles } from "./user";

import RoutingList from "../utils/RoutingList";

export const permissions = {
  // Home
  [RoutingList.index]: [
    userRoles.SUPER_ADMIN,
    userRoles.D_C,
    userRoles.STAFF,
    userRoles.SURGEON,
  ],
  // Admission
  [RoutingList.patientAdmission.index]: [
    userRoles.SUPER_ADMIN,
    userRoles.D_C,
    userRoles.STAFF,
    userRoles.SURGEON,
  ],
  [RoutingList.patientAdmission.create]: [
    userRoles.SUPER_ADMIN,
    userRoles.SURGEON,
  ],
  [RoutingList.referral.create]: [
    userRoles.SUPER_ADMIN,
    userRoles.SURGEON,
    userRoles.D_C,
    userRoles.STAFF,
  ],
  [RoutingList.patientAdmission.edit]: [
    userRoles.SUPER_ADMIN,
    userRoles.SURGEON,
  ],
  //   User
  [RoutingList.user.index]: [userRoles.SUPER_ADMIN],
  [RoutingList.user.create]: [userRoles.SUPER_ADMIN],
  [RoutingList.user.edit]: [userRoles.SUPER_ADMIN],
  //bed status
  [RoutingList.bedStatus.index]: [
    userRoles.SUPER_ADMIN,
    userRoles.D_C,
    userRoles.STAFF,
  ],
  //treatment
  [RoutingList.disease.index]: [
    userRoles.SUPER_ADMIN
  ],
  //district
  [RoutingList.district.index]: [
    userRoles.SUPER_ADMIN
  ],
  //department
  [RoutingList.department.index]: [
    userRoles.SUPER_ADMIN
  ],
  [RoutingList.department.create]: [
    userRoles.SUPER_ADMIN
  ],
  [RoutingList.department.edit]: [
    userRoles.SUPER_ADMIN
  ],
  // settings
  [RoutingList.settings.index]: [
    userRoles.SUPER_ADMIN,
    userRoles.D_C,
    userRoles.STAFF,
    userRoles.SURGEON,
  ],
  [RoutingList.settings.edit]: [
    userRoles.SUPER_ADMIN,
    userRoles.D_C,
    userRoles.STAFF,
    userRoles.SURGEON,
  ],
  [RoutingList.settings.change_password]: [
    userRoles.SUPER_ADMIN,
    userRoles.D_C,
    userRoles.STAFF,
    userRoles.SURGEON,
  ],
};
